import { Col, Row, Typography } from "antd";
import React from "react";
import { formatFullMonthName } from "../../../helpers/formatDate";

const { Paragraph } = Typography;
const SelectedReportDetails = ({ month, year, establishment }) => {
  return (
    <>
      <Row gutter={10}>
        <Col sm={6} xs={10}>
          <Paragraph
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
            ellipsis
          >
            Establishment:
          </Paragraph>
        </Col>
        <Col sm={18} xs={14}>
          <Paragraph
            strong
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
            ellipsis
          >
            {establishment}
          </Paragraph>
        </Col>
      </Row>

      <Row gutter={10}>
        <Col sm={6} xs={10}>
          <Paragraph
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
            ellipsis
          >
            Date:
          </Paragraph>
        </Col>
        <Col sm={6} xs={8}>
          <Paragraph
            strong
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
            ellipsis
          >
            {formatFullMonthName(month)}
          </Paragraph>
        </Col>
        <Col sm={6} xs={6}>
          <Paragraph
            strong
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
            ellipsis
          >
            {year}
          </Paragraph>
        </Col>
      </Row>
    </>
  );
};

export default SelectedReportDetails;
